import type { FaireProductEntity } from "../../entity_types/product";

export const p_nk32hcwmpy: FaireProductEntity = {
  token: "p_nk32hcwmpy",
  type: "product",
  name: "Hot Fudge Sundae Truffle",
  brandToken: "b_4tkquuuvuh",
  brandName: "The Chocolate Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/1bbc19b55d76ec8693358d03dc7d3e6fadb9a95ce9b7b23768cbb093310aa21b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/77d52af7e2cb596c801d2d3d234bf634eb00cd72a56793608033cbfcba54a240.jpeg",
  ],
  priceDollars: 2.08,
  description:
    "A Belgian white-chocolate truffle inspired by the classic hot fudge sundae — creamy, nostalgic, and beautifully decadent.\n\nEach piece features a milk-chocolate shell layered with smooth vanilla-cream ganache and a center of rich, liquid fudge, finished with dark-chocolate drizzle for a dessert-like presentation.\n\nThe flavor captures the timeless contrast of warm fudge and cool vanilla — sweet, silky, and perfectly balanced in every bite.\n\nOur Hot Fudge Sundae Truffle is elegant, shelf-stable, and ready for retail — ideal for cafés, gift shops, and gourmet markets seeking a nostalgic dessert favorite that ships beautifully and sells fast.\n\nAvailable in a bulk tray of 24 pieces; perfect for presenting in your candy display case, a domed platter, or for packaging in your own boxes.",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:03.369Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
